module.exports = __webpack_public_path__ + "img/guide_07.89f2f668.svg";